// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 16px;
`;
Container.displayName = 'S.Container';
